import HeaderContainer, {HeaderContainerProps} from './HeaderContainer';

export type {HeaderContainerProps};
export default HeaderContainer;
